import { UniqueReport } from './unique-report';

export class EvolutionReport {
    constructor(
      public pollName?: string,
      public evolutionReportResults?: UniqueReport[]
    ) { }

    clone() {
      return new EvolutionReport(
        this.pollName,
        this.evolutionReportResults
      );
    }
  }

